import * as React from 'react';
import { Component, Fragment } from 'react';
import styled, { withTheme } from 'styled-components';
import { propStyles } from '@kurtosys/ksys-portal-components/build/utils/propStyles';
import { Spinner } from '@kurtosys/ksys-portal-components/build/components/UI/Spinner.js';
import Translate from './Translate';
import { observer } from 'mobx-react';
import { computed } from 'mobx';

interface LoadMoreButtonProps {
    theme: { [key: string]: { prop: any } };
    onClick: () => void;
    disabled: boolean;
    isLoading: boolean;
    show?: boolean;
}

const Button = styled<any, any>('button')`
    ${propStyles};
    outline: none;
    cursor: pointer;
    opacity: ${p => (p.disabled ? 0.5 : 1)};
`;

Button.defaultProps = {
    show: true,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf: 'center',
    paddingX: 'md',
    paddingY: 'sm',
    marginY: 'md',
    height: '40px',
    minHeight: '40px',
    minWidth: '30%',
    fontSize: 'inherit',
    fontFamily: 'heading',
    fontWeight: 'medium',
    textTransform: 'uppercase',
    borderRadius: 'sm',
    borderStyle: 'none',
    boxShadow: 'sm',
    textAlign: 'center',
    color: 'white',
    bgColor: 'primary',
};

@observer
class LoadMoreButton extends Component<LoadMoreButtonProps> {
    @computed
    get buttonContent() {
        const { isLoading } = this.props;
        return isLoading ? (
            <Fragment>
                <Spinner iconSize="16px" marginX="sm" />
                <Translate>Loading</Translate>
            </Fragment>
        ) : (
            <Translate>Load More</Translate>
        );
    }

    render() {
        const { theme, onClick, disabled, show, ...props } = this.props;
        if (!show) {
            return null;
        }
        return (
            <Button
                onClick={onClick}
                disabled={disabled}
                {...props}
                {...theme.MoreButton}
            >
                {this.buttonContent}
            </Button>
        );
    }
}

export default withTheme(LoadMoreButton) as any;



// WEBPACK FOOTER //
// ./src/Components/LoadMoreButton.tsx